
import {defineComponent} from 'vue';
import {createI18n, useI18n} from "vue-i18n";
import {RouterLink, useRouter} from "vue-router";

import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
} from "@ionic/vue";
import HomeButton from "@/components/HomeButton.vue";

export default defineComponent({
  name:'Init',
  components:{
    HomeButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
  }
})
